import { render, staticRenderFns } from "./ReceivedAdd.vue?vue&type=template&id=10457b3c&scoped=true&"
import script from "./ReceivedAdd.vue?vue&type=script&lang=js&"
export * from "./ReceivedAdd.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedAdd.vue?vue&type=style&index=0&id=10457b3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10457b3c",
  null
  
)

export default component.exports